module.exports = __webpack_public_path__ + "static/img/standard-2.97deecef.png";